var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',_vm._b({attrs:{"indeterminate":"","color":"primary"}},'v-progress-circular',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }